<div class="container-fluid mcpSessionsPage py-3">
  <div class="row">

    <div class="col-12">

      <p-table
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} sesiones"
        [first]="first"
        [paginator]="!mcpSessionService.loading && filteredMcpSessions.length > 10"
        [rowHover]="true"
        [rows]="10"
        [showCurrentPageReport]="true"
        [value]="tableValue"
        (onPage)="first = $event.first">

        <!-- ---------------------------------------------------------------- -->
        <!--                          ANCHOR CAPTION                          -->
        <!-- ---------------------------------------------------------------- -->
        <ng-template pTemplate="caption">
          <div class="container-fluid px-0">

            <!-- Un solo row: el responsive se resuelve con col-12 col-lg-*,
                 no abriendo filas extra. -->
            <div class="row g-2 align-items-center">

              <div class="col-12 col-lg">
                <h1 class="mcpSessionsPage__title mb-0">Sesiones MCP</h1>
              </div>

              <div class="col-12 col-lg-auto">
                <div class="d-flex align-items-center gap-2 mcpSessionsPage__toolbar">

                  <!-- Filtra al escribir: la búsqueda es local, no hay botón
                       Buscar ni petición por tecla. -->
                  <div class="input-group mcpSessionsPage__searchGroup" role="search">
                    <label
                      class="visually-hidden"
                      for="mcpSessionsPageSearch">
                      Buscar sesión por nombre, correo, cliente o fecha
                    </label>
                    <span
                      class="input-group-text mcpSessionsPage__searchIcon"
                      aria-hidden="true">
                      <i class="material-icons">search</i>
                    </span>
                    <input
                      [(ngModel)]="searchTerm"
                      (ngModelChange)="first = 0"
                      autocomplete="off"
                      class="form-control mcpSessionsPage__searchInput"
                      id="mcpSessionsPageSearch"
                      placeholder="Nombre, correo o cliente"
                      type="search">
                  </div>

                </div>
              </div>

            </div>
          </div>
        </ng-template>

        <!-- ---------------------------------------------------------------- -->
        <!--                          ANCHOR HEADER                           -->
        <!-- ---------------------------------------------------------------- -->
        <ng-template pTemplate="header">
          <tr>
            <th>Usuario</th>
            <th class="d-none d-lg-table-cell">Perfil</th>
            <th class="d-none d-lg-table-cell">Cliente</th>
            <th class="d-none d-lg-table-cell">Último uso</th>
            <th class="d-none d-lg-table-cell">Conectado desde</th>
            <th class="text-end">
              <span class="visually-hidden">Acciones</span>
            </th>
          </tr>
        </ng-template>

        <!-- ---------------------------------------------------------------- -->
        <!--                           ANCHOR BODY                            -->
        <!-- ---------------------------------------------------------------- -->
        <ng-template pTemplate="body" let-mcpSession>

          @if (mcpSessionService.loading) {

            <!-- Esqueleto por celda: reserva el alto final de la fila para que
                 la tabla no salte al llegar los datos. -->
            <tr class="placeholder-glow" aria-hidden="true">
              <td>
                <span class="placeholder col-8 rounded d-block mcpSessionsPage__skeletonCell"></span>
                <span class="placeholder col-6 rounded d-block mcpSessionsPage__skeletonCell mt-2"></span>
              </td>
              <td class="d-none d-lg-table-cell">
                <span class="placeholder col-8 rounded d-block mcpSessionsPage__skeletonCell"></span>
              </td>
              <td class="d-none d-lg-table-cell">
                <span class="placeholder col-7 rounded d-block mcpSessionsPage__skeletonCell"></span>
              </td>
              <td class="d-none d-lg-table-cell">
                <span class="placeholder col-8 rounded d-block mcpSessionsPage__skeletonCell"></span>
              </td>
              <td class="d-none d-lg-table-cell">
                <span class="placeholder col-8 rounded d-block mcpSessionsPage__skeletonCell"></span>
              </td>
              <td class="text-end">
                <span class="placeholder rounded-circle d-inline-block mcpSessionsPage__skeletonAction"></span>
              </td>
            </tr>

          } @else {

            <tr>

              <td>
                <div class="d-flex flex-column mcpSessionsPage__cell">

                  <span
                    class="mcpSessionsPage__name text-truncate"
                    [title]="mcpSession.userFullName">
                    {{ mcpSession.userFullName }}
                  </span>

                  @if (mcpSession.hasEmail) {
                    <span
                      class="mcpSessionsPage__email text-truncate"
                      [title]="mcpSession.user.email">
                      {{ mcpSession.user.email }}
                    </span>
                  }

                  <!-- En < lg aquí baja lo que las columnas ocultas ya no
                       muestran. -->
                  <span class="mcpSessionsPage__cellMeta d-lg-none text-truncate mt-1">
                    {{ mcpSession.profileLabel }} · {{ mcpSession.clientLabel }}
                  </span>

                  <span class="mcpSessionsPage__cellMeta d-lg-none text-truncate">
                    @if (mcpSession.hasBeenUsed) {
                      Último uso: {{ mcpSession.lastUsedLabel }}
                    } @else {
                      Sin actividad
                    }
                  </span>

                  <span class="mcpSessionsPage__cellMeta d-lg-none text-truncate">
                    Conectado desde: {{ mcpSession.createdLabel }}
                  </span>

                </div>
              </td>

              <td class="d-none d-lg-table-cell">
                <span class="mcpSessionsPage__cellText">{{ mcpSession.profileLabel }}</span>
              </td>

              <td class="d-none d-lg-table-cell">
                @if (mcpSession.hasClient) {
                  <span
                    class="mcpSessionsPage__cellText mcpSessionsPage__client d-inline-block text-truncate"
                    [title]="mcpSession.clientLabel">
                    {{ mcpSession.clientLabel }}
                  </span>
                } @else {
                  <!-- Cliente desconocido NO es un error: gris, nunca rojo. -->
                  <span class="mcpSessionsPage__cellOff">{{ mcpSession.clientLabel }}</span>
                }
              </td>

              <td class="d-none d-lg-table-cell">
                @if (mcpSession.hasBeenUsed) {
                  <span class="mcpSessionsPage__cellText">{{ mcpSession.lastUsedLabel }}</span>
                } @else {
                  <!-- Sin actividad NO es un error: gris, nunca rojo. -->
                  <span class="mcpSessionsPage__cellOff">{{ mcpSession.lastUsedLabel }}</span>
                }
              </td>

              <td class="d-none d-lg-table-cell">
                <span class="mcpSessionsPage__cellText">{{ mcpSession.createdLabel }}</span>
              </td>

              <td class="text-end">
                <button
                  (click)="delete(mcpSession)"
                  type="button"
                  class="btn btn-light mcpSessionsPage__iconBtn mcpSessionsPage__iconBtn--danger"
                  ngbTooltip="Cerrar sesión"
                  placement="left"
                  container="body"
                  [attr.aria-busy]="deletingMcpSessionId === mcpSession.mcpSessionId ? 'true' : null"
                  [attr.aria-label]="'Cerrar la sesión MCP de ' + mcpSession.userFullName"
                  [disabled]="deletingMcpSessionId !== null">
                  @if (deletingMcpSessionId === mcpSession.mcpSessionId) {
                    <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                  } @else {
                    <i class="material-icons" aria-hidden="true">logout</i>
                  }
                </button>
              </td>

            </tr>

          }

        </ng-template>

        <!-- ---------------------------------------------------------------- -->
        <!--                        ANCHOR EMPTY STATE                        -->
        <!-- ---------------------------------------------------------------- -->
        <ng-template pTemplate="emptymessage">
          @if (!mcpSessionService.loading) {
            <tr>
              <td colspan="6">
                <div class="mcpSessionsPage__emptyState d-flex flex-column align-items-center justify-content-center text-center">

                  @if (isSearchEmpty) {

                    <i class="material-icons mcpSessionsPage__emptyIcon" aria-hidden="true">search_off</i>
                    <p class="mcpSessionsPage__emptyTitle mb-1">
                      Sin resultados para «{{ searchTerm.trim() }}»
                    </p>
                    <p class="mcpSessionsPage__emptyText mb-3">
                      Revisa el nombre, el correo, el cliente o la fecha, o
                      limpia la búsqueda para ver todas las sesiones.
                    </p>
                    <button
                      (click)="clearSearch()"
                      type="button"
                      class="btn btn-outline-primary mcpSessionsPage__emptyBtn">
                      Limpiar búsqueda
                    </button>

                  } @else {

                    <i class="material-icons mcpSessionsPage__emptyIcon" aria-hidden="true">hub</i>
                    <p class="mcpSessionsPage__emptyTitle mb-1">No hay sesiones MCP abiertas</p>
                    <p class="mcpSessionsPage__emptyText mb-0">
                      Aquí aparecerán las personas que se conecten al MCP desde
                      claude.ai o Claude Code.
                    </p>

                  }

                </div>
              </td>
            </tr>
          }
        </ng-template>

      </p-table>

    </div>

    <!-- ------------------------------------------------------------------ -->
    <!--                        ANCHOR LIVE REGION                          -->
    <!-- ------------------------------------------------------------------ -->
    <div class="col-12 visually-hidden" role="status" aria-live="polite">
      {{ liveMessage }}
    </div>

  </div>
</div>
